import { User } from 'interfaces';
import Image from 'next/legacy/image';

import { FullDetails, Initials } from './styles';

interface UserAvatarProps {
  user: Partial<User>;
  secondUser?: Partial<User>;
}

const formatNames = (firstName?: string, lastName?: string) => {
  if (firstName && lastName) return `${firstName} ${lastName}`;
  return firstName ? firstName : lastName ? firstName : '';
};

const formatInitials = (firstName?: string, lastName?: string) =>
  `${firstName ? firstName[0] : ''}${lastName ? lastName[0] : ''}`;

const UserAvatar = ({ user, secondUser }: Partial<UserAvatarProps>) => (
  <>
    {user?.image ? (
      <picture>
        <source srcSet={`${user?.image}?webp`} type="image/webp" />
        <source srcSet={`${user?.image}`} type="image/jpeg" />
        <Image src={`${user?.image}`} alt={'profile'} layout="fill" />
      </picture>
    ) : (
      <Initials>{formatInitials(user?.firstName, user?.lastName)}</Initials>
    )}
    <FullDetails>
      <h3>{formatNames(user?.firstName, user?.lastName)}</h3>
      {secondUser && (
        <p>{formatNames(secondUser?.firstName, secondUser?.lastName)}</p>
      )}
    </FullDetails>
  </>
);

export default UserAvatar;
